import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Open Weather Map", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_APIKeyComp = _resolveComponent("APIKeyComp")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_APIKeyComp)
  ]))
}